import React from 'react'
import { useDispatch } from 'react-redux'
import { setNewCompanyModalVisibility as setNewCompanyModalVisibilityAction } from '../../slices/company_slice'
import NewCompany from '../NewCompany'

export default function Aside() {
  const dispatch = useDispatch()

  const onClickNewCompanyButton = () => {
    dispatch(setNewCompanyModalVisibilityAction(true))
  }
  return (
    <>
      <div className="dome-d-flex dome-flex-column dome-gap6">
        <button className="dome-btn dome-btn-base dome-btn-green-stroke" onClick={onClickNewCompanyButton}>
          New Company
        </button>
      </div>
      <NewCompany />
    </>
  )
}
